import { render } from "./clientTypePortalAdd.vue?vue&type=template&id=69c6473a&scoped=true"
import script from "./clientTypePortalAdd.vue?vue&type=script&lang=js"
export * from "./clientTypePortalAdd.vue?vue&type=script&lang=js"

import "./clientTypePortalAdd.vue?vue&type=style&index=0&id=69c6473a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c6473a"]])

export default __exports__